import React from 'react'
import styles from './AdFormProgressBanner.module.css'

const ADFORM_BANNER_IMAGES = {
    DECORATION_LEFT: '/foodslaboEf/img/ProgressBanner/decoration-left.png',
    DECORATION_RIGHT: '/foodslaboEf/img/ProgressBanner/decoration-right.png',
    LOGO: '/foodslaboEf/img/ProgressBanner/foodslabo-logo.png',
} as const

export const AdFormProgressBannerHeader = () => {
    return (
        <>
            <div className={styles.sparklingLeft}>
                <img
                    src={ADFORM_BANNER_IMAGES.DECORATION_LEFT}
                    alt="decoration-left"
                />
            </div>
            <div className={styles.sparklingRight}>
                <img
                    src={ADFORM_BANNER_IMAGES.DECORATION_RIGHT}
                    alt="decoration-right"
                />
            </div>
        </>
    )
}
